export const DEFAULT_AVATAR = "/img/user_avatar.jpg";
export const DEFAULT_GRADE_IMAGE = "https://disportex.fr/3482-large_default/ceinture-judo-250cm.jpg";

export const DEFAULT_BELT_FORM = {
  belt_id: "",
  date_passage: "",
};

export const DEFAULT_DAN_FORM = {
  dominante: "",
  uv1: false,
  uv2: false,
  uv3: false,
  uv3_points: 0,
  uv4: false,
  observations: "",
};

export const DAN_ELIGIBLE_BELTS = [
  "Marron",
  "1er Dan",
  "2ème Dan",
  "3ème Dan",
  "4ème Dan",
  "5ème Dan",
];

export function safeDate(value) {
  if (!value) return null;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatGradeDate(value) {
  const date = safeDate(value);

  if (!date) return "Date non renseignée";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function getAdherentName(adherent) {
  return (
    [adherent?.prenom, adherent?.nom].filter(Boolean).join(" ") || "Judoka"
  );
}

export function getAdherentSubtitle(adherent) {
  return adherent?.club || adherent?.genre || "Profil judoka";
}

export function getSelectedAdherent(adherents = [], selectedId) {
  return adherents.find((adherent) => adherent.id === selectedId) || null;
}

export function getBeltName(grade) {
  return grade?.BeltColor?.nom || grade?.belt_name || "Ceinture";
}

export function getBeltImage(grade) {
  const beltUrl = grade?.BeltColor?.belt_url;

  if (!beltUrl) return null;

  return `/img/belt/${beltUrl}`;
}

export function sortBeltHistory(grades = []) {
  return [...grades].sort((a, b) => {
    const dateA = safeDate(a?.date_passage)?.getTime() || 0;
    const dateB = safeDate(b?.date_passage)?.getTime() || 0;

    return dateB - dateA;
  });
}

export function getLastGrade(grades = []) {
  const sorted = sortBeltHistory(grades);
  return sorted.length > 0 ? sorted[0] : null;
}

export function canAccessDanPanel(lastGrade) {
  const beltName = getBeltName(lastGrade);
  return DAN_ELIGIBLE_BELTS.includes(beltName);
}

export function getDanProgress(gradeCN) {
  if (!gradeCN) {
    return {
      completed: 0,
      total: 4,
      percent: 0,
    };
  }

  const values = [
    toBoolean(gradeCN.uv1),
    toBoolean(gradeCN.uv2),
    toBoolean(gradeCN.uv3),
    toBoolean(gradeCN.uv4),
  ];

  const completed = values.filter(Boolean).length;

  return {
    completed,
    total: 4,
    percent: Math.round((completed / 4) * 100),
  };
}

export function buildGradeStats(grades = [], lastGrade = null, gradeCN = null) {
  const danProgress = getDanProgress(gradeCN);

  return {
    totalGrades: grades.length,
    currentBelt: lastGrade ? getBeltName(lastGrade) : "Non renseignée",
    lastDate: lastGrade ? formatGradeDate(lastGrade.date_passage) : "—",
    danPercent: danProgress.percent,
    danCompleted: danProgress.completed,
    danTotal: danProgress.total,
  };
}

export function toBoolean(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value === null || value === undefined) {
    return false;
  }

  const normalized = String(value).trim().toLowerCase();

  return ["true", "1", "yes", "oui", "on"].includes(normalized);
}

export function normalizeDanFormFromApi(gradeCN) {
  return {
    dominante: gradeCN?.dominante || "",
    uv1: toBoolean(gradeCN?.uv1),
    uv2: toBoolean(gradeCN?.uv2),
    uv3: toBoolean(gradeCN?.uv3),
    uv3_points: Number(gradeCN?.uv3_points || 0),
    uv4: toBoolean(gradeCN?.uv4),
    observations: gradeCN?.observations || "",
  };
}

export function normalizeDanPayload(payload) {
  return {
    adherent_id: payload.adherent_id,
    dominante: payload.dominante || "",
    uv1: toBoolean(payload.uv1),
    uv2: toBoolean(payload.uv2),
    uv3: toBoolean(payload.uv3),
    uv3_points: Number(payload.uv3_points || 0),
    uv4: toBoolean(payload.uv4),
    observations: payload.observations || "",
  };
}

export function normalizeGradeCNFromApi(gradeCN) {
  if (!gradeCN) return null;

  return {
    ...gradeCN,
    uv1: toBoolean(gradeCN.uv1),
    uv2: toBoolean(gradeCN.uv2),
    uv3: toBoolean(gradeCN.uv3),
    uv3_points: Number(gradeCN.uv3_points || 0),
    uv4: toBoolean(gradeCN.uv4),
  };
}
